import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { HxCityService, HxRecipeService, WorkflowModel, WorkflowStepModel, WorkflowStepRequest } from 'hx-services';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { HxLabelEditComponent } from 'hx-components';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NgIf } from '@angular/common';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTagComponent } from 'ng-zorro-antd/tag';

@Component({
    selector: 'hc-workflow-step-edit',
    templateUrl: './workflow-step-edit.component.html',
    styleUrls: ['./workflow-step-edit.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, HxLabelEditComponent, EditorComponent, NzInputDirective, NgIf, NzAlertComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, NzTagComponent, TranslocoPipe]
})
export class WorkflowStepEditComponent implements OnInit {
  model!: WorkflowStepModel;
  workflow!: WorkflowModel;
  isEdit = false;
  isCreate = false;
  form!: UntypedFormGroup;

  isLoading = {
    model: false,
  };
  isSaving = false;

  constructor(
    private aRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private modal: NzModalService,
    private recipeService: HxRecipeService,
    private tr: TranslocoService,
    private cityService: HxCityService,
    private notification: NzNotificationService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['model'] as WorkflowStepModel;
    this.workflow = routeData['workflow'] as WorkflowModel;
    if (this.model) {
      this.isEdit = true;
    } else {
      this.model = {} as WorkflowStepModel;
      this.isCreate = true;
    }
    this.form = this.fb.group({
      title: [null, [Validators.required]],
      description: [null, [Validators.required]],
      order: [null, [Validators.required]],
      servicePrice: [null],
    });
    this.updateForm();
  }

  async submitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      const formModel = this.form.getRawValue() as WorkflowStepRequest;
      const model: WorkflowStepRequest = {
        id: this.model.id,
        title: formModel.title,
        description: formModel.description,
        order: formModel.order,
        servicePrice: formModel.servicePrice
      };

      this.isSaving = true;
      try {
        const result = await this.recipeService.saveWorkflowStep(this.workflow.id, model);
        this.form.markAsPristine();
        if (this.isCreate) {
          this.router.navigate([`/workflows/${this.workflow.id}/steps`]);
          this.notification.success(this.tr.translate('nav.WorkflowSteps'), this.tr.translate('nt.dataSaved'));
        } else {
          this.notification.success(this.tr.translate('nav.WorkflowSteps'), this.tr.translate('nt.dataUpdated'));
          this.isLoading.model = true;
          this.model = await this.recipeService.getWorkflowStepById(this.model.workflow.id, result.id);
          this.isLoading.model = false;
          this.updateForm();
        }
      } catch (err: any) {
        this.notification.error(this.tr.translate('nav.WorkflowSteps'), this.tr.translate(err?.error?.message));
      } finally {
        this.isSaving = false;
      }
    } else {
      console.log('not valid form', this.form.errors);
    }
  }

  private updateForm() {
    const formModel: Partial<WorkflowStepRequest> = {
      title: this.model.title,
      description: this.model.description,
      order: this.model.order,
      servicePrice: this.model.servicePrice,
    };

    this.form.patchValue(formModel);
  }
}
